import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-gray-400 py-12">
            <div className="container mx-auto px-6 text-center">
                <p>&copy; 2025 Yukti Ensure. All Rights Reserved.</p>
                <p className="text-sm mt-2">IRDAI License No: 123XYZ. This is a demonstration website.</p>
            </div>
        </footer>
    );
};

export default Footer;
